import type { IStoreOptions, Primitive } from './interfaces';
import Store from './Store';

export default class Entity<State, Parameter extends Primitive> {
    private readonly entities = new Map<Parameter, Store<State>>();

    constructor(private readonly options: IStoreOptions<State>) {}

    public store(param: Parameter): Store<State> {
        if (this.entities.has(param)) {
            return this.entities.get(param);
        }

        const key = `${this.options.key}/${param}`;

        this.entities.set(
            param,
            new Store<State>({
                ...this.options,
                key,
            }),
        );

        return this.entities.get(param);
    }
}
